import iconCalendarAdd from "assets/images/ic-calendar-add.svg";
import Button from "components/commons/button";
import MonthPicker from "components/commons/monthpicker";
import moment from "moment";

export const SelectPeriod = ({ selectedMonth, onChangeMonth, onSubmit }) => {
    const MIN_YEAR = 2021
    
    return (
        <div className={"flex flex-col space-y-10 justify-center items-center pt-28"}>
            <img src={iconCalendarAdd} alt="calendar-add" className={"mx-auto w-16"}/>
            <p className="text-neutral-70">Pilih Bulan Periode</p>
            <div className="space-y-3">
                <div className="flex items-center space-x-3">
                <MonthPicker
                    name="start_period"
                    className="w-[330px]"
                    format='YYYY-MM'
                    placeholder="Pilih Bulan"
                    value={selectedMonth?.start_period}
                    minYear={MIN_YEAR}
                    maxYear={moment().get('year')}
                    onChange={(val) => onChangeMonth('start_period', val)}
                />
                <p className="text-neutral-70">- sampai -</p>
                <MonthPicker
                    name="end_period"
                    className="w-[330px]"
                    format='YYYY-MM'
                    placeholder="Pilih Bulan"
                    value={selectedMonth?.end_period}
                    minYear={MIN_YEAR}
                    maxYear={moment().get('year')}
                    onChange={(val) => onChangeMonth('end_period', val)}
                />
                </div>
            </div>
            <Button className="w-[330px]" title="Create Happiness Index" disabled={!selectedMonth?.start_period || !selectedMonth?.end_period} onClick={onSubmit}/>
        </div>
    )
}
